import React, { useState } from "react";

import ApiData from "../../api/ApiData";

import { observer } from "mobx-react-lite";

import { InputEditVer1 } from "../UI/InputEditVer1";

import Msg from "../../api/Msg";

import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";

import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";

import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

import { SiteFormField } from "../UI/SiteFormField";

import { SiteCoordinatsField } from "./SiteCoordinatsField";

import { PRODUCTION_FORM_FIELDS } from "../../utils/productionFormFields";

import {
  COORDINATS_FORMAT_MESSAGE,
  formatCoordinatsForApi,
  formatOptionalProductionField,
  isValidCoordinatsInput,
  PRODUCTION_NAME_REQUIRED_MESSAGE,
} from "../../utils/productionCoordinats";

const NewProduction = observer(({ setFlagNewModalProduction }) => {

  const [nameProduction, setNameProduction] = useState("");
  const [productionAddress, setProductionAddress] = useState("");
  const [contactRepresentative, setContactRepresentative] = useState("");
  const [phone, setPhone] = useState("");
  const [coordinats, setCoordinats] = useState("");

  const setters = {
    name: setNameProduction,
    address: setProductionAddress,
    contact: setContactRepresentative,
    phone: setPhone,
  };

  const values = {
    name: nameProduction,
    address: productionAddress,
    contact: contactRepresentative,
    phone: phone,
  };

  const setProduction = () => {
    const nameTrimmed = String(nameProduction).trim();
    if (nameTrimmed === "") {
      return Msg.writeMessages(PRODUCTION_NAME_REQUIRED_MESSAGE);
    }

    if (!isValidCoordinatsInput(coordinats)) {
      return Msg.writeMessages(COORDINATS_FORMAT_MESSAGE);
    }

    const dataProduction = {
      company_id: Number(ApiData.company.company.id),
      name_production: nameTrimmed,
      address_production: formatOptionalProductionField(productionAddress),
      contact_representative: formatOptionalProductionField(
        contactRepresentative,
      ),
      phone: formatOptionalProductionField(phone),
      coordinats: formatCoordinatsForApi(coordinats),
    };

    ApiData.addProduction(dataProduction);

    setFlagNewModalProduction(false);
  };

  const close = () => setFlagNewModalProduction(false);

  return (
    <SideDrawer
      open
      onClose={close}
      title="Создание новой площадки"
      titleId="site-modal-new-title"
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
      footer={
        <>
          <BtnPrimaryv4 onClick={setProduction} text="Сохранить" />
          <BtnOutlineV4 onClick={close} text="Закрыть" />
        </>
      }
    >
      <div className="site-modal-body">
        <div className="site-modal-fields">
          {PRODUCTION_FORM_FIELDS.map((field) => (
            <SiteFormField key={field.id} label={field.label}>
              <InputEditVer1
                className="site-form-control"
                value={values[field.id]}
                onChange={(e) => setters[field.id](e.target.value)}
                placeholder={field.placeholder}
              />
            </SiteFormField>
          ))}
          <SiteCoordinatsField
            value={coordinats}
            onChange={(e) => setCoordinats(e.target.value)}
          />
        </div>
      </div>
    </SideDrawer>
  );
});

export default NewProduction;
